import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GetCityDetailsUseCase } from '@/core/domain/city-details/usecases/getCityDetails.usecase';
import { CityDetailsRepository } from '@/core/domain/city-details/repositories/city-details.repository';
import { CityDetailsImplRepository } from './city-details-impl.repository';

const GetCityDetailsUseCaseFactory = (
    cityDetailsRepository: CityDetailsRepository,
) => new GetCityDetailsUseCase(cityDetailsRepository);

@NgModule({
    imports: [CommonModule],
    providers: [
        {
            provide: GetCityDetailsUseCase,
            useFactory: GetCityDetailsUseCaseFactory,
            deps: [CityDetailsRepository],
        },
        {
            provide: CityDetailsRepository,
            useClass: CityDetailsImplRepository,
        },
    ],
})
export class CityDetailsDataModule {}
